/**
 * Order Service 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ItemSnapshot { 
    creationDate?: string;
    lastUpdateDate?: string;
    createdBy?: string;
    lastUpdatedBy?: string;
    objectVersionNumber?: number;
    id?: number;
    outerOrderNo?: string;
    innerOrderNo: string;
    spuId?: number;
    spuCode?: string;
    spuName?: string;
    spuType?: number;
    skuId?: number;
    skuCode?: string;
    skuName?: string;
    brandInfo?: string;
    materialInfo?: string;
    attributeInfo?: string;
    categoryInfo?: string;
    costPrice?: number;
    salePrice?: number;
    promotionPrice?: number;
    distributePrice?: number;
    marketPrice?: number;
    batchPrice?: number;
    settlePrice?: number;
    weight?: number;
    length?: number;
    width?: number;
    height?: number;
    setFlag?: number;
    fulfillmentMode?: ItemSnapshot.FulfillmentModeEnum;
    giftFlag?: number;
    multiFlag?: number;
    deleteFlag?: number;
    taxCode?: string;
    taxRate?: number;
    taxSource?: string;
    priceIncludeVat?: boolean;
}
export namespace ItemSnapshot {
    export const FulfillmentModeEnum = {
        VirtualBundle: 'VIRTUAL_BUNDLE',
        PrePacked: 'PRE_PACKED'
    } as const;
    export type FulfillmentModeEnum = typeof FulfillmentModeEnum[keyof typeof FulfillmentModeEnum];
}


